module.exports = __webpack_public_path__ + "static/media/portfolio-custom-layout-05-image-01.bbdecc8f.jpg";